export const windowSizeClasses = {
  compact: '(max-width: 599.98px)',
  medium: '(min-width: 600px) and (max-width: 839.98px)',
  expanded: '(min-width: 840px) and (max-width: 1199.98px)',
  large: '(min-width: 1200px) and (max-width: 1599.98px)',
  extraLarge: '(min-width: 1600px)'
};
